import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import {
  CANCEL_CONTRACT_RENEWAL_PENDING,
  CANCEL_CONTRACT_RENEWAL_FAILED,
  CANCEL_CONTRACT_RENEWAL_FULFILLED,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"
import { urls } from "utils-lib/builds"

export const pendingAC = () => ({
  type: CANCEL_CONTRACT_RENEWAL_PENDING,
})

export const failedAC = (fetchCode) => ({
  type: CANCEL_CONTRACT_RENEWAL_FAILED,
  payload: fetchCode,
})

export const fulfilledAC = (data) => ({
  type: CANCEL_CONTRACT_RENEWAL_FULFILLED,
  payload: data,
})

export const cancelContractRenewal =
  ({ customerId, userId, lang, payload }) =>
  (dispatch, getState) => {
    const api = `CONTRACT_RENEWAL_CANCEL`
    const template = URITemplate(urls.url[api])
    const url = template.expand({
      customerId,
      userId,
      lang,
    })

    const config = {
      method: `POST`,
      headers: {},
      data: payload,
    }

    return getTokenAction(dispatch, getState).then(async (res) => {
      config.headers.oktaToken = res.accessToken
      config.headers.apiKey = get(urls, `apiKey.USER[${api}]`, ``)
      return cancelContractRenewalHelper(url, config, dispatch)
    })
  }

export const cancelContractRenewalHelper = (url, config, dispatch) => {
  dispatch(pendingAC())

  return axios(url, config)
    .then((response) => {
      dispatch(fulfilledAC(response.data))

      return response.data
    })
    .catch((error) => {
      dispatch(failedAC(error?.response?.status))
      return error?.response?.status
    })
}
